module.exports = __webpack_public_path__ + "img/use-app-1.3c9c7cf9.jpg";